module.exports = __webpack_public_path__ + "components/country-flag/static/si-6cedaf2524d5067910b9b3807c649ca7.svg";